import api from '@/api/api'
export const backIndexMixin = {
  data() {
    return { indexUrl: '' }
  },
  created() {
      this.getIndex()
  },
  methods: {
    getIndex() {
      api.base.index().then(res => {
        if (res.data.code == 200) {
          this.indexUrl = res.data.data.webIndexPath
        }
      })
    },
    handleBackIndex() {
      location.href = this.indexUrl
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/backIndexMixin.js